export { default } from './ListOneTicketStudies';
